import type { Channel } from '@wolhasudang/shared';

export interface NavigationOwnership {
  owner: 'product' | 'provider';
  showProductHeader: boolean;
  showProductBackControls: boolean;
}

export function resolveNavigationOwnership(channel: Channel): NavigationOwnership {
  const providerOwnsNavigation = channel === 'toss';
  return {
    owner: providerOwnsNavigation ? 'provider' : 'product',
    showProductHeader: !providerOwnsNavigation,
    showProductBackControls: !providerOwnsNavigation,
  };
}
